const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/emails/forms/new.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
interface NewFormSearch {
  prefill_token?: string;
}
export const Route = createFileRoute("/_protected/_settingsLayout/settings/emails/forms/new")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: (search: Record<string, unknown>): NewFormSearch => ({
    prefill_token: search.prefill_token as string | undefined
  })
});